import { Pagination } from "react-bootstrap";

const PaginationAdvanced = ({ arrayData, handleSearchData }) => {
    const totalPages = arrayData?.last_page;
    const currentPage = arrayData?.current_page;

    if (totalPages <= 1) return null;

    const getPageItems = () => {
        const items = [];

        // Tombol First & Prev
        items.push(
            <Pagination.First key="first" onClick={() => handleSearchData(1)} disabled={currentPage === 1} />,
            <Pagination.Prev key="prev" onClick={() => handleSearchData(currentPage - 1)} disabled={currentPage === 1} />
        );

        // Halaman 1
        if (currentPage > 2) {
            items.push(
                <Pagination.Item key={1} onClick={() => handleSearchData(1)}>
                    1
                </Pagination.Item>
            );
            if (currentPage > 3) {
                items.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
            }
        }

        // Halaman sekitar current page
        for (let page = currentPage - 1; page <= currentPage + 1; page++) {
            if (page > 0 && page <= totalPages) {
                items.push(
                    <Pagination.Item
                        key={page}
                        active={page === currentPage}
                        onClick={() => handleSearchData(page)}
                    >
                        {page}
                    </Pagination.Item>
                );
            }
        }

        // Halaman terakhir
        if (currentPage < totalPages - 1) {
            if (currentPage < totalPages - 2) {
                items.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
            }
            items.push(
                <Pagination.Item key={totalPages} onClick={() => handleSearchData(totalPages)}>
                    {totalPages}
                </Pagination.Item>
            );
        }

        // Tombol Next & Last
        items.push(
            <Pagination.Next key="next" onClick={() => handleSearchData(currentPage + 1)} disabled={currentPage === totalPages} />,
            <Pagination.Last key="last" onClick={() => handleSearchData(totalPages)} disabled={currentPage === totalPages} />
        );

        return items;
    };

    return <Pagination>{getPageItems()}</Pagination>;
};

export default PaginationAdvanced;
